import React from "react";

interface CardQualityBadgeProps {
  qualityLabel: string;
}

export default function CardQualityBadge({
  qualityLabel,
}: CardQualityBadgeProps): React.JSX.Element {
  return (
    <span className="bg-muted text-muted-foreground rounded px-1 py-0.5 text-[0.78125rem] font-medium">
      {qualityLabel}
    </span>
  );
}
